<template>
  <div>
    <sidebar-component></sidebar-component>
    <div class="relative md:ml-64 bg-blueGray-100">
      <navbar-component></navbar-component>
      <!-- Header -->
      <div class="relative bg-blue-600 md:pt-32 pb-32 pt-12">
        <div class="rounded-t mb-0 px-4 py-3 border-0">
          <div
            class="container mx-auto my-12 h-auto flex flex-wrap justify-between items-start text-sm p-8 pt-8 pb-4 box-border border-4 border-gray-400 bg-gray-100"
          >
            <a class="text-2xl text-center text-black font-bold"
              >Solicitação : Alterar Saída (Venda) : {{ situacao }}</a
            >
            <RouterLinkButton
              btnText=""
              color="sky"
              tipo="fas"
              icone="arrow-left"
              url="/solicitacao"
            />
            <div class="bg-green-500 w-full h-1"></div>
            <div class="mx-auto py-4">
              <div class="flex flex-wrap font-bold text-gray-100">
                <div class="w-full mt-4">
                  <div class="text-gray-900 text-xl">
                    Código : {{ id_solicitacao }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-green-500 w-full h-1"></div>
            <TextInput
              label=""
              placeholder=""
              v-model:input="id_cliente"
              inputType="hidden"
              readonly
            />
            <a class="text-sky-400 font-bold"
              >Cliente : {{ id_cliente }}-{{ razaoSocial_cliente }}</a
            >
            <div>
              <button
                class="bg-gray-400 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                v-on:click="toggleModalCustomer()"
              >
                Escolha o Cliente que pertence a venda !
              </button>
              <div
                v-if="showModalCustomer"
                class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
              >
                <div class="relative w-auto my-6 mx-auto max-w-3xl">
                  <!--content-->
                  <div
                    class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
                  >
                    <!--header-->
                    <div
                      class="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t"
                    >
                      <h3 class="text-3xl font-semibold">Cliente</h3>
                      <button
                        class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        v-on:click="toggleModalCustomer()"
                      >
                        <span
                          class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none"
                        >
                          ×
                        </span>
                      </button>
                    </div>
                    <!--body-->
                    <div class="relative p-6 flex-auto">
                      <div class="flex mt-4 mb-8">
                        <div class="w-full md:w-1/2 px-3">
                          <TextInput
                            label="Digitar o nome do cliente"
                            placeholder="Pesquisar..."
                            v-model:input="searchCustomer"
                            inputType="text"
                          />
                        </div>
                        <div class="w-full md:w-1/2 px-3">
                          <form
                            @submit.prevent="onSubmit"
                            @click="getCustomerList"
                          >
                            <LoadingButton
                              :isLoading="isLoading"
                              class="block w-full bg-green-500 text-white rounded-sm py-3 text-sm tracking-wide transform motion-safe:hover:-translate-y-1 text-blue-700 motion-safe:hover:scale-110 transition ease-in-out"
                            >
                              Pesquisar
                            </LoadingButton>
                          </form>
                        </div>
                        <div class="mx-auto py-4">
                          <table class="table-auto text-xs">
                            <thead>
                              <tr class="text-gray-600 bg-gray-300">
                                <th class="border px-4 py-2">Id</th>
                                <th class="border px-4 py-2">Cliente</th>
                                <th class="border px-4 py-2">Ação</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                class="text-gray-500 bg-gray-100"
                                v-for="listCustomer in listCustomers"
                                :key="listCustomer"
                              >
                                <td>{{ listCustomer.id }}</td>
                                <td>{{ listCustomer.razaoSocial }}</td>
                                <td>
                                  <div
                                    class="block w-full bg-green-500 text-white rounded-sm py-3 text-sm tracking-wide transform motion-safe:hover:-translate-y-1 text-blue-700 motion-safe:hover:scale-110 transition ease-in-out"
                                  >
                                    <SubmitFormButton
                                      btnText="Escolha"
                                      @click="selectCustomer(listCustomer)"
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="flex items-center justify-center p-2">
                            <v-pagination
                              v-model="pageCustomers"
                              :pages="pageCountCustomers"
                              :range-size="1"
                              active-color="#337aff"
                              @update:modelValue="listCustomers"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <vue-snotify />
                    <!--footer-->
                    <div
                      class="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b"
                    >
                      <button
                        class="text-sky-500 bg-transparent border border-solid border-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        v-on:click="toggleModalCustomer()"
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showModalCustomer"
                class="opacity-25 fixed inset-0 z-40 bg-black"
              ></div>
            </div>
            <div class="bg-green-500 w-full h-1"></div>
            <div class="w-full md:w-full px-3">
              <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
                <div
                  class="w-full border px-4 py-2 rounded focus:border-blue-500 focus:shadow-outline outline-none"
                >
                  <div class="w-full text-gray-900 md:w-full px-6">
                    <TextInputDate
                      label="Data emissão"
                      placeholder="Digitar emissão !"
                      v-model:input="dt_emissao"
                      inputType="text"
                    />
                  </div>
                  <div class="w-full text-gray-900 md:w-full px-6">
                    <TextInputMoeda
                      label="Vlr Solicitação"
                      placeholder="Valor total"
                      v-model:input="valorTotalPedido"
                      inputType="hidden"
                      readonly
                    />
                    {{ valorTotalPedido }}
                  </div>
                  <a class="text-2xl text-center text-black font-bold">
                    FORMA DE PAGAMENTO
                  </a>
                  <div class="grid grid-cols-4 gap-4">
                    <div class="w-full text-gray-700 md:w-auto px-3">
                      <TextInputMoeda
                        label="Vlr a vista"
                        placeholder="Vlr a vista"
                        v-model:input="vlrTotalavista"
                        inputType="hidden"
                        readonly
                      />
                      {{ vlrTotalavista }}
                    </div>
                    <div>
                      <div class="w-full text-gray-700 md:w-auto px-3">
                        <TextInputMoeda
                          label="Vlr a prazo"
                          placeholder="Vlr a prazo"
                          v-model:input="vlrTotalaprazo"
                          inputType="hidden"
                          reandonly
                        />
                        {{ vlrTotalaprazo }}
                      </div>
                    </div>
                    <div>
                      <div class="w-full text-gray-700 md:w-auto px-3">
                        <TextInputMoeda
                          label="Vlr débito"
                          placeholder="Vlr débito"
                          v-model:input="vlrTotaldebito"
                          inputType="hidden"
                          reandonly
                        />
                        {{ vlrTotaldebito }}
                      </div>
                    </div>
                    <div>
                      <div class="w-full text-gray-700 md:w-auto px-3">
                        <TextInputMoeda
                          label="Vlr crédito"
                          placeholder="Vlr crédito"
                          v-model:input="vlrTotalcredito"
                          inputType="hidden"
                          reandonly
                        />
                        {{ vlrTotalcredito }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="situacao !== 'CANCELADO'"
              class="flex flex-wrap mt-8 mb-6"
            >
              <div class="bg-green-500 w-full h-1"></div>
              <form @submit.prevent="onSubmit" @click="update">
                <LoadingButton
                  :isLoading="isLoading"
                  class="block w-full bg-green-500 text-white rounded-sm py-3 text-sm tracking-wide transform motion-safe:hover:-translate-y-1 text-blue-700 motion-safe:hover:scale-110 transition ease-in-out"
                >
                  Alterar
                </LoadingButton>
              </form>
              <vue-snotify />
            </div>
            <div class="bg-green-500 w-full h-1"></div>
            <div class="text-gray-600 text-xl">Itens da solicitação</div>
            <div class="bg-green-500 w-full h-1"></div>
            <table class="table-auto text-xs">
              <thead>
                <tr class="text-gray-600 bg-gray-300">
                  <th class="border px-4 py-2">ID</th>
                  <th class="border px-4 py-2">Código barras</th>
                  <th class="border px-4 py-2">Descrição</th>
                  <th class="border px-4 py-2">Quantidade</th>
                  <th class="border px-4 py-2">Vlr unitario</th>
                  <th class="border px-4 py-2">Vlr total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-gray-500 bg-gray-100"
                  v-for="listSolicitItem in listSolicitItems"
                  :key="listSolicitItem"
                >
                  <td>{{ listSolicitItem.id }}</td>
                  <td>{{ listSolicitItem.codigo_barra }}</td>
                  <td>{{ listSolicitItem.nome_produto }}</td>
                  <td>{{ listSolicitItem.quantidade }}</td>
                  <td>{{ listSolicitItem.valor_unitario }}</td>
                  <td>{{ listSolicitItem.valor_totalProduto }}</td>
                </tr>
              </tbody>
            </table>
            <div class="bg-green-500 w-full h-1"></div>
            <div class="flex items-center justify-center p-2">
              <v-pagination
                v-model="pageItems"
                :pages="pageCountItems"
                :range-size="1"
                active-color="#337aff"
                @update:modelValue="getSolicitItemList"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ref } from "vue";
import NavbarComponent from "@/components/Navbar.vue";
import SidebarComponent from "@/components/Sidebar.vue";
import AdmMenuComponent from "@/components/parcial/adm/AdmMenu.vue";
import RouterLinkButton from "@/components/global/RouterLinkButton.vue";
import TextInput from "@/components/global/TextInput.vue";
import TextInputDate from "@/components/global/TextInputDate.vue";
import TextInputMoeda from "@/components/global/TextInputMoeda.vue";
import LoadingButton from "@/components/global/LoadingButton.vue";
import SubmitFormButton from "@/components/global/SubmitFormButton.vue";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store/user-store";
import { useSolicitationStore } from "@/store/solicitation-store";

export default {
  components: {
    NavbarComponent,
    SidebarComponent,
    AdmMenuComponent,
    RouterLinkButton,
    LoadingButton,
    TextInput,
    SubmitFormButton,
    TextInputDate,
    TextInputMoeda,
  },
  name: "regular-modal",
  data() {
    const userStore = useUserStore();
    const SolicitationStore = useSolicitationStore();
    const route = useRoute();
    const router = useRouter();

    const url = process.env.VUE_APP_API_URL;
    let hover = ref(false);
    let showModal = ref(false);
    let showModalCustomer = ref(false);
    let showModalProduct = ref(false);
    let showModalProductCB = ref(false);

    let searchCompany = ref(null);
    let listCompanies = ref(null);
    let pageCompanies = ref(1);
    let pageCountCompanies = ref(null);

    let errors = ref([]);

    return {
      date: new Date().getFullYear(),
      useradministrador: userStore.administrador,
      userid_company: userStore.id_empresa,
      id_responsavel: userStore.id,
      name_responsavel: userStore.full_name,
      SolicitationStore: SolicitationStore,
      route: route,
      router: router,
      url_api: url,
      hover: hover,
      showModal: showModal,
      showModalCustomer: showModalCustomer,
      showModalProduct: showModalProduct,
      showModalProductCB: showModalProductCB,
      searchCompany: searchCompany,
      listCompanies: listCompanies,
      pageCompanies: pageCompanies,
      pageCountCompanies: pageCountCompanies,
      listStocks: ref(null),
      searchStock: ref(null),
      searchStockCB: ref(null),
      pageStocks: ref(1),
      pageCountStocks: ref(null),
      searchCustomer: ref(null),
      listCustomers: ref(null),
      pageCustomers: ref(1),
      pageCountCustomers: ref(null),
      listSolicitItems: ref(null),
      pageItems: ref(null),
      pageCountItems: ref(null),
      errors: errors,
      error: errors,
      id_empresa: ref(null),
      razaoSocial_empresa: ref(null),
      isLoading: ref(false),
      id_solicitacao: ref(null),
      id_cliente: ref(null),
      razaoSocial_cliente: ref(null),
      dt_emissao: ref(null),
      dt_retirada: ref(null),
      dt_entrega: ref(null),
      vlrtotal_item: ref(null),
      quantidade: ref(null),
      vlrunitario: ref(null),
      modelo: ref("pedidovenda"),
      situacao: ref(null),
      valorTotalPedido: ref(0),
      vlrTotalavista: ref(0),
      vlrTotalaprazo: ref(0),
      vlrTotaldebito: ref(0),
      vlrTotalcredito: ref(0),
    };
  },
  methods: {
    async getSolicitationsale() {
      // Make a GET request to the API
      const response = await this.SolicitationStore.fetchByIdSolicitation(
        this.route.params.id
      );
      this.id_solicitacao = this.SolicitationStore.id_solicitacao || null;
      this.id_cliente = this.SolicitationStore.id_cliente || null;
      this.razaoSocial_cliente =
        this.SolicitationStore.razaoSocial_cliente || null;
      this.dt_emissao = this.SolicitationStore.dt_emissao || null;
      // this.dt_retirada = this.SolicitationStore.dt_retirada || null;
      // this.dt_entrega = this.SolicitationStore.dt_entrega || null;
      this.situacao = this.SolicitationStore.situacao || null;
      this.valorTotalPedido = this.SolicitationStore.valorTotalPedido || null;
      this.vlrTotalavista = this.SolicitationStore.vlrTotalavista || null;
      this.vlrTotalaprazo = this.SolicitationStore.vlrTotalaprazo || null;
      this.vlrTotaldebito = this.SolicitationStore.vlrTotaldebito || null;
      this.vlrTotalcredito = this.SolicitationStore.vlrTotalcredito || null;
      this.$snotify.info("Aguarde atualizando ... !");
    },
    getCompanyList() {
      // Make a GET request to the API
      axios
        .get(
          this.url_api +
            "/api/companysearch/" +
            this.searchCompany +
            "?page=" +
            this.pageCompanies
        )
        .then((response) => {
          // Handle the successful response
          // console.log(response.data);
          this.pageCountCompanies = response.data.page_count1;
          this.listCompanies = response.data.paginate1.data;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error fetching data:", error);
          this.$snotify.error("Verifique novamente !");
        });
    },
    getCustomerList() {
      axios
        .get(
          this.url_api +
            "/api/customersearch/" +
            this.searchCustomer +
            "?page=" +
            this.pageCustomers
        )
        .then((response) => {
          // Handle the successful response
          //console.log(response.data);
          this.pageCountCustomers = response.data.page_countCustomer;
          this.listCustomers = response.data.paginateCustomer.data;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error fetching data:", error);
          this.$snotify.error("Verifique novamente !");
        });
    },
    getStockListProd() {
      axios
        .get(
          this.url_api +
            "/api/stocksearch/" +
            this.id_cliente +
            "/" +
            this.searchStock +
            "?page=" +
            this.pageStocks
        )
        .then((response) => {
          // Handle the successful response
          // console.log(response.data);
          this.pageCountStocks = response.data.page_count;
          this.listStocks = response.data.paginate.data;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error fetching data:", error);
          this.$snotify.error("Verifique novamente !");
        });
    },
    getStockListProdCB() {
      axios
        .get(
          this.url_api +
            "/api/stocksearchCB/" +
            this.id_cliente +
            "/" +
            this.searchStockCB +
            "?page=" +
            this.pageStocks
        )
        .then((response) => {
          // Handle the successful response
          // console.log(response.data);
          this.pageCountStocks = response.data.page_count;
          this.listStocks = response.data.paginate.data;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error fetching data:", error);
          this.$snotify.error("Verifique novamente !");
        });
    },
    getSolicitItemList() {
      axios
        .get(
          this.url_api +
            "/api/salesoitemlist/" +
            this.route.params.id +
            "?page=" +
            this.pageItems
        )

        // console.log(resItem)

        .then((response) => {
          // Handle the successful response
          // console.log(response.data);
          this.pageCountItems = response.data.page_countItem;
          this.listSolicitItems = response.data.paginateItem.data;
          this.vlrtotal = response.data.valorTotalPedido;
        })
        .catch((error) => {
          // Handle any errors
          console.error("Error fetching data:", error);
          this.$snotify.error("Verifique novamente !");
        });
    },

    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleModalCustomer() {
      this.showModalCustomer = !this.showModalCustomer;
    },
    toggleModalProduct() {
      this.showModalProduct = !this.showModalProduct;
    },
    toggleModalProductCB() {
      this.showModalProductCB = !this.showModalProductCB;
    },
    selectCompany(event) {
      this.id_cliente = event.id;
      this.razaoSocial = event.razaoSocial;

      if (this.userid_company !== this.id_cliente) {
        this.$snotify.error("Empresa não pertence a : " + this.razaoSocial);
        this.id_cliente = null;
        this.razaoSocial = null;
      } else {
        this.$snotify.warning("Escolheu a : " + this.razaoSocial);
      }
    },
    selectCustomer(event) {
      this.id_cliente = event.id;
      this.razaoSocial_cliente = event.razaoSocial;
      this.$snotify.warning("Escolheu a : " + this.razaoSocial_cliente);
    },
    selectProduct(event) {
      this.id_produto = event.id;
      this.nome_produto = event.nome_produto;
      this.codigo_barra = event.codigo_barra;
      this.descricao = event.nome_produto;
      this.unidade = event.unidade;
      this.vlrunitario = event.preco_venda;

      this.$snotify.warning("Escolheu a : " + this.nome_produto);
    },
    formatMoeda(moedaString) {
      const atual = moedaString;

      const valorFormatado = Intl.NumberFormat("pt-br", {
        style: "currency",
        currency: "BRL",
      }).format(atual);

      return valorFormatado;
    },
    onSubmit() {
      this.isLoading = true;
      setTimeout(() => (this.isLoading = false), 1000);
    },
    multiplicarprod() {
      // alert(`Selecionou !`)
      this.vlrtotal_item = this.quantidade * this.vlrunitario;
    },
    update() {
      // console.log('Dentro update')

      this.error = [];
      let data = new FormData();
      data.append("id_responsavel", this.id_responsavel || "");
      data.append("id_cliente", this.id_cliente || "");
      data.append("dt_vendacupom", this.dt_emissao || "");
      // data.append("dt_retirada", this.dt_retirada || "");
      // data.append("dt_entrega", this.dt_entrega || "");
      data.append("valorTotalPedido", this.valorTotalPedido || "");
      data.append("modelo", this.modelo || "");
      // console.log(data)
      axios
        .put(this.url_api + "/api/salesorder/" + this.route.params.id, {
          id_responsavel: this.id_responsavel,
          id_cliente: this.id_cliente,
          dt_vendacupom: this.dt_emissao,
          // dt_retirada: this.dt_retirada,
          // dt_entrega: this.dt_entrega,
          valorTotalPedido: this.valorTotalPedido,
          modelo: this.modelo,
        })
        .then(() => {
          // console.log(teste)
          this.$snotify.success("Salvo com sucesso !");
        })
        .catch((error) => {
          // Handle any errors
          // this.errors = error.data.error;
          console.error("Error salesorderentry:", this.error);
          this.$snotify.error("Verificar Empresa, Cliente ou as datas !");
          return error;
        });
    },
    onPageChange() {
      this.getSolicitationsale();
      this.getSolicitItemList();
      this.getCompanyList();
      this.getCustomerList();
      this.getStockListProd();
      this.getStockListProdCB();
      this.update();
    },
  },
  mounted() {
    this.getSolicitationsale();
    this.getSolicitItemList();
  },
};
</script>
